import { Button, Form, Input, message, Select } from 'antd';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { useUserContext } from 'features/users';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

type props = {
    closeModal: () => void;
    isOpen: boolean;
    modalType: string
};

interface GroupFilterTicket {
    GroupName: string;
    GroupId: any;
}

interface GroupFilterApiResponse {
    GroupList: GroupFilterTicket[];
}

export const GroupRegistrationModal = ({
    closeModal,
    isOpen,
    modalType
}: props) => {
    const { user } = useUserContext();
    const userHasAccessToEventList: any = user?.user_id != 107093;

    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    // const [grpeventId, setGrpeventId] = useState<string | null>(null);

    const [form] = Form.useForm();
    const { t } = useTranslation();

    const [loading, setLoading] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [selected, setSelected] = useState('All');

    const transaction = [
        { value: "all", label: "All" },
        { value: "captured", label: "Captured" },
        { value: "uncaptured", label: "UnCaptured" }
    ];

    const handleClose = () => {
        form.resetFields();
        closeModal();
        setTickets([]);
    };

    const onFinish = (formValues: any) => {
        handleExport(formValues);
    };

    const handleExport = async (values: any) => {
        setLoading(true);
        try {
            const group_names =
                typeof values.group_names === 'string'
                    ? values.group_names.toLowerCase() === 'all' || values.group_names.toLowerCase() === 'undefined'
                        ? ''
                        : values.group_names
                    : values.group_names ?? '';

            const params = {
                event_id: values.event_name,
                BulkUploadId: group_names,
                transaction_status: values.transaction_status,
                FileName: values.file_name,
                type: "GroupParticiapantReport",
            };

            const response: any = await TransectionApiServices().exportGroupListRegistraionByEventId(params);

            if (response?.ResponseStatus == 1) {
                setLoading(false);
                setIsSuccess(true);
                form.resetFields()
            } else {
                message.error(response.ResponseMessage);
            }
        } catch (error) {
            message.error("File doesn't contain valid data");
        } finally {
            setLoading(false);
        }
    };

    const [event, setEvent] = useState({
        items: []
    });

    const [tickets, setTickets] = useState(
        [{ label: 'All', value: 'All' }]
    );

    const getEvent = async () => {
        try {
            const apires = await TransectionApiServices().getDropDownList(`Flag=${'Events'}`);
            setEvent(apires as any);
        } catch (error) {
            message.error('');
        }
    };

    // ⭐ FIXED → Now accepts eventId
    const getGroupNameList = async (value: string, eventId?: string) => {
        form.setFieldsValue({ group_names: '' });

        if (value === 'All') {
            setTickets([{ label: 'All', value: '' }]);
            
return;
        }

        try {
            const response = await TransectionApiServices().getGroupNameListByEventId(
                `EventId=${eventId}&Status=${value}`
            );

            const apires = response as GroupFilterApiResponse;
            setTickets([
                { label: 'All', value: '' },
                ...apires.GroupList.map((res) => ({ label: res.GroupName, value: res.GroupId }))
            ]);
        } catch (error) {
            message.error('');
        }
    };

    useEffect(() => {
        if (isOpen) {
            getEvent();
            form.setFieldValue("transaction_status", "all");
            setIsSuccess(false);
            setSelected('All');
        }
    }, [isOpen, form]);

    useEffect(() => {
        if (selected !== "All") {
            form.setFields([
                { name: "Date_From", errors: [], value: null },
                { name: "Date_To", errors: [], value: null },
            ]);
        }
    }, [selected, form]);


    const formatTitle = (title: string) => {
        if (!title) return '';

        const capitalized = title.charAt(0).toUpperCase() + title.slice(1);
        const formatted = capitalized.replace(/([a-z])([A-Z])/g, '$1 $2');
        
return formatted;
    };

    return (
        <div className='popup'>
            <div className='modal_head'>
                <h4>{formatTitle(modalType)} Export</h4>
                <button onClick={handleClose} className='close-btn'>
                    &times;
                </button>
            </div>

            <div className='modal_body'>
                <Form
                    form={form}
                    layout='vertical'
                    onFinish={onFinish}
                    onFinishFailed={() => setValidateTrigger(['onChange'])}
                    validateTrigger={validateTrigger}
                >
                    <FormSectionsSeparator title={""}>

                        {modalType === "GroupRegisrationReport" && (
                            <>
                                {/* ⭐ EVENT DROPDOWN FIXED */}
                                <Form.Item
                                    label={'Event Name'}
                                    name={"event_name"}
                                    rules={[
                                        { required: true, message: t('validateMessages.custom.nomsg') },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        options={event?.items
                                            ?.filter((res: any) =>
                                                (res.Id === 732 && !userHasAccessToEventList) ||
                                                (res.Id === res.Id && userHasAccessToEventList)
                                            )
                                            ?.map((res: any) => ({
                                                label: res.Text,
                                                value: res.Id
                                            }))}
                                        placeholder={"Select Event Name"}

                                        // ⭐ FIXED → Pass eventId directly
                                        onChange={(value: string) => {
                                            // setGrpeventId(value);

                                            const status = form.getFieldValue("transaction_status");
                                            if (status === "all") {
                                                getGroupNameList("all", value);
                                            }
                                        }}

                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </>
                        )}

                        {/* ⭐ TRANSACTION STATUS FIXED */}
                        <Form.Item
                            label={'Transaction Status'}
                            name={"transaction_status"}
                        >
                            <Select
                                placeholder='Select Transaction Status'
                                options={transaction}
                                onChange={(value: string) => {
                                    const eventId = form.getFieldValue("event_name");
                                    getGroupNameList(value, eventId); // ⭐ FIXED
                                }}
                            />
                        </Form.Item>

                        {/* GROUP NAMES */}
                        <Form.Item
                            label={'Group Names'}
                            name={"group_names"}
                        >
                            <Select
                                showSearch
                                options={tickets}
                                placeholder={"Select Group Name"}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>

                        <Form.Item
                            label={'File Name'}
                            name={"file_name"}
                            rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                        >
                            <Input placeholder={'Enter File Name'} />
                        </Form.Item>

                    </FormSectionsSeparator>

                    {!isSuccess &&
                        <Button type='primary' htmlType='submit' loading={loading}>
                            Generate Report
                        </Button>
                    }

                </Form>

                {isSuccess && (
                    <div className='gnrte_rprt'>
                        <h2>
                            Preparing Your Report<span className="loading">...</span>
                        </h2>

                        <h3>
                            To Check your report status and access the file, Please <Link to={ROUTES.TRANSACTION__REPORTS}>Click here</Link>
                        </h3>
                    </div>
                )}
            </div>
        </div>
    );
};
